import { render, staticRenderFns } from "./ConsigmentInfoModal.vue?vue&type=template&id=03e1d1aa&"
import script from "./ConsigmentInfoModal.vue?vue&type=script&lang=js&"
export * from "./ConsigmentInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports